import { Layout, Menu, Avatar, Dropdown, Space } from 'antd';
import {
  HomeOutlined,
  PictureOutlined,
  BookOutlined,
  UserOutlined,
  LogoutOutlined,
  MessageOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuthHook';

const { Header } = Layout;

const Topbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { username: routeUsername } = useParams();

  // 从当前路径获取 username（用于未登录访问公开页面）
  const pathUsername = location.pathname.match(/^\/([^\/]+)/)?.[1];

  // 确定使用哪个 username：优先使用路由参数，其次使用 pathUsername，最后使用 user.username
  const currentUsername = routeUsername || pathUsername || (user ? user.username : null);

  // 导航菜单项 - 未登录时根据当前页面的 username 显示公开页面链接
  const navItems = currentUsername ? [
    {
      key: '/' + currentUsername + '/index/',
      icon: <HomeOutlined />,
      label: '首页',
    },
    {
      key: '/' + currentUsername + '/album/',
      icon: <PictureOutlined />,
      label: '相册',
    },
    {
      key: '/' + currentUsername + '/blog/',
      icon: <BookOutlined />,
      label: '博客',
    },
    {
      key: '/' + currentUsername + '/iden/profile/',
      icon: <UserOutlined />,
      label: '个人信息',
    },
    ...(user ? [
      {
        key: '/' + currentUsername + '/iden/message/',
        icon: <MessageOutlined />,
        label: '留言',
      },
      {
        key: '/' + currentUsername + '/iden/follow/',
        icon: <UserSwitchOutlined />,
        label: '关注',
      },
    ] : []),
  ] : [
    {
      key: '/iden/',
      icon: <UserOutlined />,
      label: '登录',
    },
  ];

  // 用户下拉菜单项
  const userMenuItems = user ? [
    {
      key: '/' + user.username + '/iden/manage/',
      icon: <UserOutlined />,
      label: '个人资料',
      onClick: () => navigate('/' + user.username + '/iden/manage/'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: logout,
    },
  ] : [
    {
      key: 'login',
      icon: <UserOutlined />,
      label: '登录',
      onClick: () => navigate('/iden/'),
    },
  ];

  return (
    <Header style={{
      padding: '0 24px',
      background: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      zIndex: 1000,
      position: 'sticky',
      top: 0
    }}>
      {/* 左侧：应用标题 */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ fontSize: '20px', fontWeight: 'bold', marginRight: '40px' }}>
          rtycn
        </span>
        
        {/* 顶部导航菜单 */}
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={navItems}
          onClick={({ key }) => navigate(key)}
          style={{
            borderBottom: 'none',
            background: 'transparent',
            lineHeight: '64px'
          }}
        />
      </div>

      {/* 右侧：用户信息 */}
      <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
        <Space style={{ cursor: 'pointer' }}>
          <Avatar src={user?.avatar} icon={<UserOutlined />} />
          <span>{user?.username || '游客'}</span>
        </Space>
      </Dropdown>
    </Header>
  );
};

export default Topbar;